import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ViewReasonComponent } from 'src/app/admin/components/view-reason/view-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-physical-infra-page',
  templateUrl: './physical-infra-page.component.html',
  styleUrls: ['./physical-infra-page.component.css'],
})
export class PhysicalInfraPageComponent implements OnInit {
  settingsForm: FormGroup;
  private saveApi = environment.url + environment.phyInfSave;
  private getApi = environment.url + environment.phyInfGet;
  /**
   * Component for the physical infrastructure page
   */
  constructor(
    private cdRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    /**
     * The form group for the page
     */
    this.settingsForm = this.fb.group({
      // question 001
      dedicatedAreaIncCentre: [''],
      dedicatedAreaDocuments: new FormArray([]),
      dedicatedAreaImagefile: [''],
      dedicatedAreaSqftArea: [''],
      dedicatedAreaStatus: [''],

      // question 002
      officeAndCoWorkingSpaceIncCentre: [''],
      officeAndCoWorkingSpaceDocuments: new FormArray([]),
      officeAndCoWorkingSpaceImagefile: [''],
      officeAndCoWorkingSpaceStatus: [''],

      // question 003
      makerSpacePrototypeIncCentre: [''],
      makerSpacePrototypeDocuments: new FormArray([]),
      makerSpacePrototypeUrlIcWebsite: [''],
      makerSpacePrototypeImagefile: [''],
      makerSpacePrototypeUtilitySpace: [''],
      makerSpacePrototypeStatus: [''],

      // question 004
      specializedSoftwareIncCentre: [''],
      specializedSoftwareDocuments: new FormArray([]),
      specializedSoftwareImagefile: [''],
      specializedSoftwareStatus: [''],

      // question 005
      mvpsAndProjectsIncCentre: [''],
      mvpsAndProjectsDocuments: new FormArray([]),
      mvpsAndProjectsUrlIcWebsite: [''],
      mvpsAndProjectsImagefile: [''],
      mvpsAndProjectsUrlNoOfMVP: [''],
      mvpsAndProjectsStatus: [''],

      // question 006
      separateMeetingIncCentre: [''],
      separateMeetingDocuments: new FormArray([]),
      separateMeetingUrlIcWebsite: [''],
      separateMeetingImagefile: [''],
      separateMeetingUrlNoOfFacility: [''],
      separateMeetingStatus: [''],

      // question 007
      facilityTimingsIncCentre: [''],
      facilityTimingsDocuments: new FormArray([]),
      facilityTimingsUrlIcWebsite: [''],
      facilityTimingsImagefile: [''],
      facilityTimings: [''],
      facilityTimingsStatus: [''],

      // question 008
      trainingsConductedIncCentre: [''],
      trainingsConductedDocuments: new FormArray([]),
      trainingsConductedImagefile: [''],
      trainingsConductedStatus: [''],
      trainingsConductedCount: [''],

      // question 009
      policyForCoCreationIncCentre: [''],
      policyForCoCreationDocuments: new FormArray([]),
      policyForCoCreationImagefile: [''],
      policyForCoCreationStatus: [''],

      // question 010
      provisionForStakeholdersIncCentre: [''],
      provisionForStakeholdersDocuments: new FormArray([]),
      provisionForStakeholdersImagefile: [''],
      provisionForStakeholdersStatus: [''],

      // new 9th question
      startupsUtilizingOffSpaceCentre: [''],
      startupsUtilizingOffSpaceDocuments: new FormArray([]),
      startupsUtilizingOffSpaceImagefile: [''],
      startupsUtilizingOffSpaceStatus: [''],
      startupsUtilizingOffSpaceTotalPercent: [''],

      // new 12th question
      hackathonsConductedCentre: [''],
      hackathonsConductedDocuments: new FormArray([]),
      hackathonsConductedImagefile: [''],
      hackathonsConductedNoOfHackathons: [''],
      hackathonsConductedStatus: [''],

      // question 013
      revenueGeneratedUsingSpaceCentre: [''],
      revenueGeneratedUsingSpaceDocuments: new FormArray([]),
      provisionForStakeholdersNoOfVisitor: [''],
      revenueGeneratedUsingSpaceImagefile: [''],
      revenueGeneratedUsingSpaceStatus: [''],
    });
    /**
     * The media query for the mobile view
     */
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    /**
     * The listener for the media query
     */
    this._mobileQueryListener = () => this.cdRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  get setting() {
    return this.settingsForm.controls;
  }
  /**
   * This method is called on the initialization of the component
   * It calls the {@link getPush} method to get the push notification permission
   * It calls the {@link getDataApi} method to get the data from the API
   * It calls the {@link guidelineDatas} method to get the guideline data from the API
   */
  ngOnInit(): void {
    this.getPush();
    this.getDataApi();
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches data from the API, updates the settings form and manages file uploads.
   */
  getDataApi() {
    // Show loading indicator
    this.getdata.amizhthLoader('show');

    // Make API call to fetch data
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        // Hide loading indicator
        this.getdata.amizhthLoader('hide');
        this.getValue = data;

        // Check if the API response is successful
        if (data.responseStatus != 'Failed') {
          this.settingsForm.patchValue(data);

          // Handle options based on data attributes
          this.handleOptions(data);

          // Handle document uploads
          this.handleDocuments(data);

          // Update form with new values
          this.settingsForm.patchValue(this.settingsForm.value);
        }
      });
  }

  /**
   * Handles the display of options based on data attributes.
   * The method loops through the options array and calls the relevant method based on the data attribute value.
   * If the data attribute value is 'Yes', the method calls the showOptions method with the relevant arguments.
   * @param data - Data from the API response
   */
  private handleOptions(data: any) {
    const options = [
      {
        key: 'dedicatedAreaIncCentre',
        method: this.showOptionsone,
        upload: '.upload0',
        succ: '.set-succ0',
      },
      {
        key: 'officeAndCoWorkingSpaceIncCentre',
        method: this.showOptionstwo,
        upload: '.upload1',
        succ: '.set-succ1',
      },
      {
        key: 'makerSpacePrototypeIncCentre',
        method: this.showOptionsthree,
        upload: '.upload2',
        succ: '.set-succ2',
      },
      {
        key: 'specializedSoftwareIncCentre',
        method: this.showOptionsfour,
        upload: '.upload3',
        succ: '.set-succ3',
      },
      {
        key: 'mvpsAndProjectsIncCentre',
        method: this.showOptionsfive,
        upload: '.upload4',
        succ: '.set-succ4',
      },
      {
        key: 'separateMeetingIncCentre',
        method: this.showOptionssix,
        upload: '.upload5',
        succ: '.set-succ5',
      },
      {
        key: 'facilityTimingsIncCentre',
        method: this.showOptionsseven,
        upload: '.upload6',
        succ: '.set-succ6',
      },
      {
        key: 'programsschemesIncCentre',
        method: this.showOptions8,
        upload: '.upload7',
        succ: '.set-succ7',
      },
      {
        key: 'policyForCoCreationCentre',
        method: this.showOptions9,
        upload: '.upload8',
        succ: '.set-succ8',
      },
      {
        key: 'provisionForStakeholdersIncCentre',
        method: this.showOptions10,
        upload: '.upload9',
        succ: '.set-succ9',
      },
      {
        key: 'startupsUtilizingOffSpaceCentre',
        method: this.showOptions11,
        upload: '.upload10',
        succ: '.set-succ10',
      },
      {
        key: 'hackathonsConductedCentre',
        method: this.showOptions12,
        upload: '.upload11',
        succ: '.set-succ11',
      },
      {
        key: 'revenueGeneratedUsingSpaceCentre',
        method: this.showOptions13,
        upload: '.upload12',
        succ: '.set-succ12',
      },
    ];

    options.forEach((option, index) => {
      // If the data attribute value is 'Yes', call the showOptions method with the relevant arguments
      if (data[option.key] == 'Yes') {
        option.method.call(this, 'Yes', option.upload, index, option.succ);
      }
    });
  }

  /**
   * Handles document uploads and UI updates for each document type.
   * @param data - Data from the API response
   */
  private handleDocuments(data: any) {
    const documents = [
      {
        key: 'dedicatedAreaDocuments',
        image: 'dedicatedAreaImagefile',
        index: 0,
        succ: '.set-succ0',
        upload: '.upload0',
        remove: '.remove-wrapper.upload0',
      },
      {
        key: 'officeAndCoWorkingSpaceDocuments',
        image: 'officeAndCoWorkingSpaceImagefile',
        index: 1,
        succ: '.set-succ1',
        upload: '.upload1',
        remove: '.remove-wrapper.upload1',
      },
      {
        key: 'makerSpacePrototypeDocuments',
        image: 'makerSpacePrototypeImagefile',
        index: 2,
        succ: '.set-succ2',
        upload: '.upload2',
        remove: '.remove-wrapper.upload2',
      },
      {
        key: 'specializedSoftwareDocuments',
        image: 'specializedSoftwareImagefile',
        index: 3,
        succ: '.set-succ3',
        upload: '.upload3',
        remove: '.remove-wrapper.upload3',
      },
      {
        key: 'mvpsAndProjectsDocuments',
        image: 'mvpsAndProjectsImagefile',
        index: 4,
        succ: '.set-succ4',
        upload: '.upload4',
        remove: '.remove-wrapper.upload4',
      },
      {
        key: 'separateMeetingDocuments',
        image: 'separateMeetingImagefile',
        index: 5,
        succ: '.set-succ5',
        upload: '.upload5',
        remove: '.remove-wrapper.upload5',
      },
      {
        key: 'facilityTimingsDocuments',
        image: 'facilityTimingsImagefile',
        index: 6,
        succ: '.set-succ6',
        upload: '.upload6',
        remove: '.remove-wrapper.upload6',
      },
      {
        key: 'trainingsConductedDocuments',
        image: 'trainingsConductedImagefile',
        index: 7,
        succ: '.set-succ7',
        upload: '.upload7',
        remove: '.remove-wrapper.upload7',
      },
      {
        key: 'policyForCoCreationDocuments',
        image: 'policyForCoCreationImagefile',
        index: 8,
        succ: '.set-succ8',
        upload: '.upload8',
        remove: '.remove-wrapper.upload8',
      },
      {
        key: 'provisionForStakeholdersDocuments',
        image: 'provisionForStakeholdersImagefile',
        index: 9,
        succ: '.set-succ9',
        upload: '.upload9',
        remove: '.remove-wrapper.upload9',
      },
      {
        key: 'startupsUtilizingOffSpaceDocuments',
        image: 'startupsUtilizingOffSpaceImagefile',
        index: 10,
        succ: '.set-succ11',
        upload: '.upload10',
        remove: '.remove-wrapper.upload10',
      },
      {
        key: 'hackathonsConductedDocuments',
        image: 'hackathonsConductedImagefile',
        index: 11,
        succ: '.set-succ12',
        upload: '.upload11',
        remove: '.remove-wrapper.upload11',
      },
      {
        key: 'revenueGeneratedUsingSpaceDocuments',
        image: 'revenueGeneratedUsingSpaceImagefile',
        index: 12,
        succ: '.set-succ12',
        upload: '.upload12',
        remove: '.remove-wrapper.upload12',
      },
    ];

    documents.forEach((doc) => {
      if (data[doc.key] != '' && data[doc.key] != undefined) {
        this.documentValues[doc.index] = data[doc.key];
        this.settingsForm.value[doc.image] = data[doc.key][0].documentFile;
        setTimeout(() => {
          $(doc.succ).addClass('success');
          $(doc.upload).addClass('d-none').removeClass('success');
          $(doc.remove).addClass('d-flex active');
        }, 5000);
      }
    });
  }
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Opens a dialog to display the reason for the given status.
   * @param status - The status object or value to show the reason for.
   */
  viewReasonBtn(status: any) {
    const dialogRef = this.dialog.open(ViewReasonComponent, {
      width: '390px',
      data: { _status: status },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // No action needed after the dialog is closed.
    });
  }
  /**
   * Updates the value of a form control in the settings form.
   * @param event - The event that triggered this function (not used).
   * @param key - The name of the form control to update.
   * @param value - The value to set the form control to.
   */
  setStatus(event: any, key: string, value: any) {
    this.settingsForm.controls[key].setValue(value);
  }
  /**
   * Populates the `documentValues` array with 14 new document request objects,
   * each containing empty `documentName` and `documentFile` fields.
   */
  getPush() {
    for (let i = 0; i < 14; i++) {
      // Create a new document request object with empty fields
      const req = [
        {
          documentName: '',
          documentFile: '',
        },
      ];
      // Add the object to the array
      this.documentValues.push(req);
    }
  }
  selecetdFile: any = [];
  url: any;
  ImageValue: any = '';
  ImageType: any;
  documentValues = [];
  /**
   * Handles file upload events, processes selected files, updates form controls, and UI states.
   * Accepts only jpeg, jpg, png, and pdf files.
   *
   * @param event - The file input change event.
   * @param val - A value used for UI selector construction.
   * @param i - Index indicating which document/form control to update.
   * @param set - Selector or reference for additional UI updates.
   */
  fileUpload(event: any, val: string, i: number, set: string) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];

      if (
        img_crt_type == 'jpeg' ||
        img_crt_type == 'jpg' ||
        img_crt_type == 'png' ||
        img_crt_type == 'pdf'
      ) {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          let splType = this.selecetdFile.type.split('/');
          this.url = reader.result;
          let spl = this.url.split(',');
          let val = this.documentValues[i];
          val[0].documentFile = spl[1];
          val[0].documentName = this.selecetdFile.name;
          this.documentValues[i] = val;
          // Update form control values based on the index
          switch (i) {
            case 0:
              this.settingsForm.controls['dedicatedAreaStatus'].setValue(7);
              this.settingsForm.controls['dedicatedAreaImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 1:
              this.settingsForm.controls[
                'officeAndCoWorkingSpaceStatus'
              ].setValue(7);
              this.settingsForm.controls[
                'officeAndCoWorkingSpaceImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 2:
              this.settingsForm.controls['makerSpacePrototypeStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'makerSpacePrototypeImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 3:
              this.settingsForm.controls['specializedSoftwareStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'specializedSoftwareImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 4:
              this.settingsForm.controls['mvpsAndProjectsStatus'].setValue(7);
              this.settingsForm.controls['mvpsAndProjectsImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 5:
              this.settingsForm.controls['separateMeetingStatus'].setValue(7);
              this.settingsForm.controls['separateMeetingImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 6:
              this.settingsForm.controls['facilityTimingsStatus'].setValue(7);
              this.settingsForm.controls['facilityTimingsImagefile'].setValue(
                this.selecetdFile.name
              );
              break;
            case 7:
              this.settingsForm.controls['trainingsConductedStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'trainingsConductedImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 8:
              this.settingsForm.controls['policyForCoCreationStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'policyForCoCreationImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            case 9:
              this.settingsForm.controls[
                'provisionForStakeholdersStatus'
              ].setValue(7);
              this.settingsForm.controls[
                'provisionForStakeholdersImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            // new 9th
            case 10:
              this.settingsForm.controls[
                'startupsUtilizingOffSpaceStatus'
              ].setValue(7);
              this.settingsForm.controls[
                'startupsUtilizingOffSpaceImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            // new 12th
            case 11:
              this.settingsForm.controls['hackathonsConductedStatus'].setValue(
                7
              );
              this.settingsForm.controls[
                'hackathonsConductedImagefile'
              ].setValue(this.selecetdFile.name);
              break;
            // new 13th
            case 12:
              this.settingsForm.controls[
                'revenueGeneratedUsingSpaceStatus'
              ].setValue(7);
              this.settingsForm.controls[
                'revenueGeneratedUsingSpaceImagefile'
              ].setValue(this.selecetdFile.name);
              break;
          }
        };
        setTimeout(function () {
          let datass = '.upload-wrapper' + val;
          $(datass).addClass('uploaded');
        }, 600);
        setTimeout(function () {
          let datas = '.upload-wrapper' + val;
          $(datas).removeClass('uploaded');
          $(datas).addClass('success');
          $(set).addClass('success');
        }, 1600);
        setTimeout(function () {
          let datas = '.upload-wrapper' + val;
          $(datas).addClass('d-none');
          $(datas).removeClass('success');
          let data = '.remove-wrapper' + val;
          $(data).addClass('d-flex');
          $(data).addClass('active');
        }, 5000);
      } else {
        this.notify.notifyError(
          'Only *jpeg,*jpg,*png formet images are allowed'
        );
      }
    }
  }
  /**
   * Removes the file and updates the UI and form controls.
   * Clears the document file and name, and resets the UI elements.
   *
   * @param val - A value used for UI selector construction.
   * @param i - Index indicating which document/form control to update.
   * @param set - Selector or reference for additional UI updates.
   */
  removeFile(val, i, set) {
    // Clear document file and name in documentValues array
    this.documentValues[i][0].documentFile = '';
    this.documentValues[i][0].documentName = '';

    // Update UI to reflect file removal
    setTimeout(() => {
      const datass = '.upload-wrapper' + val;
      $(datass).removeClass('d-none');
      const data = '.remove-wrapper' + val;
      $(data).removeClass('d-flex');
      $(data).removeClass('active');
      $(set).removeClass('success');
    }, 1000);

    // Update form controls based on the index
    const controlMap = [
      'dedicatedAreaImagefile',
      'officeAndCoWorkingSpaceImagefile',
      'makerSpacePrototypeImagefile',
      'specializedSoftwareImagefile',
      'mvpsAndProjectsImagefile',
      'separateMeetingImagefile',
      'facilityTimingsImagefile',
      'trainingsConductedImagefile',
      'policyForCoCreationImagefile',
      'provisionForStakeholdersImagefile',
      'startupsUtilizingOffSpaceImagefile',
      'hackathonsConductedImagefile',
      'revenueGeneratedUsingSpaceImagefile',
    ];

    if (controlMap[i]) {
      this.settingsForm.controls[controlMap[i]].setValue('');
    }
  }
  Optionsonechecked = '';
  showOptionsone(event, val, i, set) {
    this.Optionsonechecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['dedicatedAreaStatus'].setValue(1);
      this.settingsForm.controls['dedicatedAreaSqftArea'].setValue('');
      this.settingsForm.controls['dedicatedAreaSqftArea'].clearValidators();
      this.settingsForm.controls['dedicatedAreaImagefile'].setValue('');
      this.settingsForm.controls['dedicatedAreaImagefile'].clearValidators();
    } else {
      this.settingsForm.controls['dedicatedAreaSqftArea'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['dedicatedAreaImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'dedicatedAreaSqftArea'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'dedicatedAreaImagefile'
    ].updateValueAndValidity();
  }
  Optionstwochecked = '';
  showOptionstwo(event, val, i, set) {
    this.Optionstwochecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['officeAndCoWorkingSpaceStatus'].setValue(1);
      this.settingsForm.controls['officeAndCoWorkingSpaceImagefile'].setValue(
        ''
      );
      this.settingsForm.controls[
        'officeAndCoWorkingSpaceImagefile'
      ].clearValidators();
    } else {
      this.settingsForm.controls[
        'officeAndCoWorkingSpaceImagefile'
      ].setValidators([Validators.required]);
    }
    this.settingsForm.controls[
      'officeAndCoWorkingSpaceImagefile'
    ].updateValueAndValidity();
  }
  Optionsthreechecked = '';
  showOptionsthree(event, val, i, set) {
    this.Optionsthreechecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['makerSpacePrototypeStatus'].setValue(1);
      this.settingsForm.controls['makerSpacePrototypeUtilitySpace'].setValue(
        ''
      );
      this.settingsForm.controls['makerSpacePrototypeUrlIcWebsite'].setValue(
        ''
      );
      this.settingsForm.controls['makerSpacePrototypeImagefile'].setValue('');
      this.settingsForm.controls[
        'makerSpacePrototypeUrlIcWebsite'
      ].clearValidators();
      this.settingsForm.controls[
        'makerSpacePrototypeImagefile'
      ].clearValidators();
      this.settingsForm.controls[
        'makerSpacePrototypeUtilitySpace'
      ].clearValidators();
    } else {
      this.settingsForm.controls[
        'makerSpacePrototypeUtilitySpace'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'makerSpacePrototypeUrlIcWebsite'
      ].setValidators([Validators.required, RxwebValidators.url()]);
      this.settingsForm.controls['makerSpacePrototypeImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'makerSpacePrototypeUtilitySpace'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'makerSpacePrototypeUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'makerSpacePrototypeImagefile'
    ].updateValueAndValidity();
  }
  Optionsfourchecked = '';
  showOptionsfour(event, val, i, set) {
    this.Optionsfourchecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['specializedSoftwareStatus'].setValue(1);
      this.settingsForm.controls['specializedSoftwareImagefile'].setValue('');
      this.settingsForm.controls[
        'specializedSoftwareImagefile'
      ].clearValidators();
    } else {
      this.settingsForm.controls['specializedSoftwareImagefile'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'specializedSoftwareImagefile'
    ].updateValueAndValidity();
  }
  Optionsfivechecked = '';
  showOptionsfive(event, val, i, set) {
    this.Optionsfivechecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['mvpsAndProjectsStatus'].setValue(1);
      this.settingsForm.controls['mvpsAndProjectsUrlIcWebsite'].setValue('');
      this.settingsForm.controls['mvpsAndProjectsImagefile'].setValue('');
      this.settingsForm.controls['mvpsAndProjectsUrlNoOfMVP'].setValue('');
      this.settingsForm.controls[
        'mvpsAndProjectsUrlIcWebsite'
      ].clearValidators();
      this.settingsForm.controls['mvpsAndProjectsImagefile'].clearValidators();
      this.settingsForm.controls['mvpsAndProjectsUrlNoOfMVP'].clearValidators();
    } else {
      this.settingsForm.controls['mvpsAndProjectsUrlIcWebsite'].setValidators([
        Validators.required,
        RxwebValidators.url(),
      ]);
      this.settingsForm.controls['mvpsAndProjectsImagefile'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['mvpsAndProjectsUrlNoOfMVP'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'mvpsAndProjectsUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'mvpsAndProjectsImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'mvpsAndProjectsUrlNoOfMVP'
    ].updateValueAndValidity();
  }
  Optionssixchecked = '';
  showOptionssix(event, val, i, set) {
    this.Optionssixchecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['separateMeetingStatus'].setValue(1);
      this.settingsForm.controls['separateMeetingUrlIcWebsite'].setValue('');
      this.settingsForm.controls['separateMeetingImagefile'].setValue('');
      this.settingsForm.controls['separateMeetingUrlNoOfFacility'].setValue('');
      this.settingsForm.controls[
        'separateMeetingUrlIcWebsite'
      ].clearValidators();
      this.settingsForm.controls['separateMeetingImagefile'].clearValidators();
      this.settingsForm.controls[
        'separateMeetingUrlNoOfFacility'
      ].clearValidators();
    } else {
      this.settingsForm.controls['separateMeetingUrlIcWebsite'].setValidators([
        Validators.required,
        RxwebValidators.url(),
      ]);
      this.settingsForm.controls['separateMeetingImagefile'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls[
        'separateMeetingUrlNoOfFacility'
      ].setValidators([Validators.required]);
    }
    this.settingsForm.controls[
      'separateMeetingUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'separateMeetingImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'separateMeetingUrlNoOfFacility'
    ].updateValueAndValidity();
  }
  Optionssevenchecked = '';
  showOptionsseven(event, val, i, set) {
    this.Optionssevenchecked = event;
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['facilityTimingsStatus'].setValue(1);
      this.settingsForm.controls['facilityTimingsUrlIcWebsite'].setValue('');
      this.settingsForm.controls['facilityTimingsImagefile'].setValue('');
      this.settingsForm.controls['facilityTimings'].setValue('');
      this.settingsForm.controls[
        'facilityTimingsUrlIcWebsite'
      ].clearValidators();
      this.settingsForm.controls['facilityTimingsImagefile'].clearValidators();
      this.settingsForm.controls['facilityTimings'].clearValidators();
    } else {
      this.settingsForm.controls['facilityTimingsUrlIcWebsite'].setValidators([
        Validators.required,
        RxwebValidators.url(),
      ]);
      this.settingsForm.controls['facilityTimingsImagefile'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['facilityTimings'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'facilityTimingsUrlIcWebsite'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'facilityTimingsImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls['facilityTimings'].updateValueAndValidity();
  }
  Options8checked;
  showOptions8(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['trainingsConductedStatus'].setValue(1);
      this.settingsForm.controls['trainingsConductedImagefile'].setValue('');
      this.settingsForm.controls[
        'trainingsConductedImagefile'
      ].clearValidators();
      this.settingsForm.controls['trainingsConductedCount'].setValue('');
      this.settingsForm.controls['trainingsConductedCount'].clearValidators();
    } else {
      this.settingsForm.controls['trainingsConductedImagefile'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls['trainingsConductedCount'].setValidators([
        Validators.required,
      ]);
    }
    this.settingsForm.controls[
      'trainingsConductedImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'trainingsConductedCount'
    ].updateValueAndValidity();
  }
  Options9checked;
  showOptions9(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['policyForCoCreationStatus'].setValue(1);
      this.settingsForm.controls['policyForCoCreationImagefile'].setValue('');
      this.settingsForm.controls[
        'policyForCoCreationImagefile'
      ].clearValidators();
    } else {
      this.settingsForm.controls['policyForCoCreationImagefile'].setValidators([
        Validators.required,
      ]);
    }

    this.settingsForm.controls[
      'policyForCoCreationImagefile'
    ].updateValueAndValidity();
  }
  Options10checked = '';
  showOptions10(event, val, i, set) {
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['provisionForStakeholdersStatus'].setValue(1);
      this.settingsForm.controls[
        'provisionForStakeholdersNoOfVisitor'
      ].setValue('');
      this.settingsForm.controls[
        'provisionForStakeholdersNoOfVisitor'
      ].clearValidators();
      this.settingsForm.controls['provisionForStakeholdersImagefile'].setValue(
        ''
      );
      this.settingsForm.controls[
        'provisionForStakeholdersImagefile'
      ].clearValidators();
    } else {
      this.settingsForm.controls[
        'provisionForStakeholdersNoOfVisitor'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'provisionForStakeholdersImagefile'
      ].setValidators([Validators.required]);
    }
    this.settingsForm.controls[
      'provisionForStakeholdersNoOfVisitor'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'provisionForStakeholdersImagefile'
    ].updateValueAndValidity();
  }
  // new 9th
  Options11checked = '';
  /**
   * Handles the change event for the 'Startups Utilizing Office Space' option.
   * Updates the form controls based on the selected option.
   * @param event - The value of the selected option ('Yes' or 'No').
   * @param val - Additional value used for the operation.
   * @param i - Index for control identification.
   * @param set - Additional set information for operation.
   */
  showOptions11(event, val, i, set) {
    // If 'No' is selected, remove the associated file and clear values and validators
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['startupsUtilizingOffSpaceStatus'].setValue(1);
      this.settingsForm.controls['startupsUtilizingOffSpaceImagefile'].setValue(
        ''
      );
      this.settingsForm.controls[
        'startupsUtilizingOffSpaceImagefile'
      ].clearValidators();
      this.settingsForm.controls[
        'startupsUtilizingOffSpaceTotalPercent'
      ].setValue('');
      this.settingsForm.controls[
        'startupsUtilizingOffSpaceTotalPercent'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators for image file and total percent
      this.settingsForm.controls[
        'startupsUtilizingOffSpaceImagefile'
      ].setValidators([Validators.required]);
      this.settingsForm.controls[
        'startupsUtilizingOffSpaceTotalPercent'
      ].setValidators([Validators.required]);
    }
    // Update the validity of the form controls
    this.settingsForm.controls[
      'startupsUtilizingOffSpaceImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'startupsUtilizingOffSpaceTotalPercent'
    ].updateValueAndValidity();
  }
  // new 12th
  Options12checked = '';
  /**
   * Updates form controls related to 'Hackathons Conducted' based on the radio button selection.
   * @param event The selected value of the radio button.
   * @param val The value used to identify the file input.
   * @param i The index related to the file input.
   * @param set The suffix to identify specific form controls.
   */
  showOptions12(event, val, i, set) {
    // If 'No' is selected, remove the file and clear values and validators.
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['hackathonsConductedStatus'].setValue(1);
      this.settingsForm.controls['hackathonsConductedImagefile'].setValue('');
      this.settingsForm.controls[
        'hackathonsConductedImagefile'
      ].clearValidators();
      this.settingsForm.controls['hackathonsConductedNoOfHackathons'].setValue(
        ''
      );
      this.settingsForm.controls[
        'hackathonsConductedNoOfHackathons'
      ].clearValidators();
    } else {
      // If 'Yes' is selected, set required validators.
      this.settingsForm.controls['hackathonsConductedImagefile'].setValidators([
        Validators.required,
      ]);
      this.settingsForm.controls[
        'hackathonsConductedNoOfHackathons'
      ].setValidators([Validators.required]);
    }
    // Update the validity of the form controls.
    this.settingsForm.controls[
      'hackathonsConductedImagefile'
    ].updateValueAndValidity();
    this.settingsForm.controls[
      'hackathonsConductedNoOfHackathons'
    ].updateValueAndValidity();
  }
  // new 13th
  Options13checked = '';
  /**
   * Show/hide form controls based on the 'Revenue Generated Using Space'
   * radio button selection.
   * @param event The selected value of the radio button.
   * @param val The value to be used to set the form controls.
   * @param i The index of the form control.
   * @param set The suffix to be added to the form control name.
   */
  showOptions13(event, val, i, set) {
    // If the user selects 'No' then remove the image file and clear the validators.
    if (event == 'No') {
      this.removeFile(val, i, set);
      this.settingsForm.controls['revenueGeneratedUsingSpaceStatus'].setValue(
        1
      );
      this.settingsForm.controls[
        'revenueGeneratedUsingSpaceImagefile'
      ].setValue('');
      this.settingsForm.controls[
        'revenueGeneratedUsingSpaceImagefile'
      ].clearValidators();
    }
    // If the user selects 'Yes' then add the required validator.
    else {
      this.settingsForm.controls[
        'revenueGeneratedUsingSpaceImagefile'
      ].setValidators([Validators.required]);
    }
    // Update the validity of the form control.
    this.settingsForm.controls[
      'revenueGeneratedUsingSpaceImagefile'
    ].updateValueAndValidity();
  }
  /**
   * Initiates the save operation for the settings form.
   * Checks the form validity and submits data if valid.
   */
  saveBtn() {
    let getform = this.settingsForm.value;

    // Check if the form is invalid
    if (this.settingsForm.invalid) {
      // Mark all fields as touched to display validation errors
      this.settingsForm.markAllAsTouched();
      // Notify user about mandatory fields
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Attach documents to the form data if available
      if (this.documentValues[0][0].documentFile != '') {
        getform.dedicatedAreaDocuments = this.documentValues[0];
      }
      if (this.documentValues[1][0].documentFile != '') {
        getform.officeAndCoWorkingSpaceDocuments = this.documentValues[1];
      }
      if (this.documentValues[2][0].documentFile != '') {
        getform.makerSpacePrototypeDocuments = this.documentValues[2];
      }
      if (this.documentValues[3][0].documentFile != '') {
        getform.specializedSoftwareDocuments = this.documentValues[3];
      }
      if (this.documentValues[4][0].documentFile != '') {
        getform.mvpsAndProjectsDocuments = this.documentValues[4];
      }
      if (this.documentValues[5][0].documentFile != '') {
        getform.separateMeetingDocuments = this.documentValues[5];
      }
      if (this.documentValues[6][0].documentFile != '') {
        getform.facilityTimingsDocuments = this.documentValues[6];
      }
      if (this.documentValues[7][0].documentFile != '') {
        getform.trainingsConductedDocuments = this.documentValues[7];
      }
      if (this.documentValues[8][0].documentFile != '') {
        getform.policyForCoCreationDocuments = this.documentValues[8];
      }
      if (this.documentValues[9][0].documentFile != '') {
        getform.provisionForStakeholdersDocuments = this.documentValues[9];
      }
      // Attach new documents if available
      if (this.documentValues[10][0].documentFile != '') {
        getform.startupsUtilizingOffSpaceDocuments = this.documentValues[10];
      }
      if (this.documentValues[11][0].documentFile != '') {
        getform.hackathonsConductedDocuments = this.documentValues[11];
      }
      if (this.documentValues[12][0].documentFile != '') {
        getform.revenueGeneratedUsingSpaceDocuments = this.documentValues[12];
      }

      // Show loading indicator
      this.getdata.amizhthLoader('show');

      // Perform API request to save the form data
      this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
        // Hide loading indicator
        this.getdata.amizhthLoader('hide');
        // Check the response status
        if (data.responseStatus == 'Success') {
          // Move to the next step
          this.step++;
          // Notify success
          this.notify.notifysuccess(data.responseMessage);
          // Refresh data from API
          this.getDataApi();
        } else {
          // Notify error
          this.notify.notifyError(data.responseMessage);
        }
      });
    }
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  /**
   * This function is used to fetch the guideline data from the json file.
   * The data is then used to populate the guidelines modal.
   */
  guidelineDatas() {
    /**
     * The http.get method is used to fetch the guideline json file.
     * The subscribe method is used to get the response from the server.
     */
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      /**
       * The guidelineValue is set to the questions array in the json file.
       * This array is then used to populate the guidelines modal.
       */
      this.guidelineValue = data[4].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.saveBtn();
  }
  prevStep() {
    this.step--;
  }
}
